// extracted by mini-css-extract-plugin
module.exports = {"gallery":"_1oaiL","cell":"_3zb4C","imageWrapper":"_38AaJ","image":"_3dFI4"};